import Form from "@subly/s1/ui/atom/Form";

import core from "core";
import { usePaywall, useWelcomeSystem } from "../fabric";
import Actions from "./Actions";

export default function System() {
	const { form, cms } = useWelcomeSystem();

	return (
		<Form>
			<form.AppField name="cms" listeners={{ onChange: () => form.setFieldValue("paywall", "") }}>
				{(field) => <field.Autocomplete
					label="CMS"
					freeSolo
					inputValue={cms.data?.find(c => c.value == field.state.value)?.label ?? (field.state.value ?? "")}
					options={cms.data || []}
					onInputChange={(_, v, reason) => { if (reason === "input") field.handleChange(v); }}
					onChange={(_, v) => field.handleChange(core.is.string(v) ? v : (v?.value || ""))}
					required
				/>}
			</form.AppField>

			<form.Subscribe selector={(state) => state.values.cms}>
				{(cms) => {
					const paywalls = usePaywall(cms);
					return (
						<form.AppField name="paywall">
							{(field) => <field.Autocomplete
								label="Paywall"
								freeSolo
								inputValue={paywalls.data?.find(c => c.value == field.state.value)?.label ?? (field.state.value ?? "")}
								options={paywalls.data || []}
								onInputChange={(_, v, reason) => { if (reason === "input") field.handleChange(v); }}
								onChange={(_, v) => field.handleChange(core.is.string(v) ? v : (v?.value || ""))}
								required
							/>}
						</form.AppField>
					);
				}}
			</form.Subscribe>
			<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
				{([canSubmit, isSubmitting]) => <Actions canSubmit={canSubmit} isSubmitting={isSubmitting} onClick={form.handleSubmit} />}
			</form.Subscribe>
		</Form>
	);
};